// extracted by mini-css-extract-plugin
export default {"container":"CheckBox_container__GfN8Y","checkbox":"CheckBox_checkbox__-cvc9"};